import { render } from "./KontaktKpk.vue?vue&type=template&id=85e33be6"
import script from "./KontaktKpk.vue?vue&type=script&lang=js"
export * from "./KontaktKpk.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__